<svg viewBox="0 0 60 30" style="width: 150px; height: 75px; margin:auto">
  <path class="heartbeat" d="
      M0,15 
      L5,15 
      L8,5 
      L11,25 
      L14,15 
      L20,15 
      L23,10 
      L26,20 
      L29,15 
      L60,15" />

  <!-- {{messageText}} -->